import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Trash2 } from 'lucide-react';
import VineyardsListToolbar from '../components/toolbars/VineyardsListToolbar';
import '../index.css';

const VineyardsList = () => {
    const [vineyards, setVineyards] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        fetchVineyards();
    }, []);

    const fetchVineyards = async () => {
        try {
            const response = await axios.get('/api/vineyards');
            setVineyards(response.data);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching vineyards:', error);
            setLoading(false);
        }
    };

    const handleEdit = (id, e) => {
        e?.stopPropagation();
        navigate(`/vineyards/edit/${id}`);
    };

    const handleDelete = async (id, e) => {
        e?.stopPropagation();
        if (window.confirm('Are you sure you want to delete this vineyard?')) {
            try {
                await axios.delete(`/api/vineyards/${id}`);
                setVineyards(vineyards.filter(vineyard => vineyard.id !== id));
                alert('Vineyard deleted successfully');
            } catch (error) {
                console.error('Error deleting vineyard:', error);
                alert('Failed to delete vineyard');
            }
        }
    };

    if (loading) {
        return (
            <>
                <VineyardsListToolbar 
                    onAddVineyard={() => navigate('/vineyards/new')}
                    onAddWeighTag={() => navigate('/weight-tags')}
                />
                <div className="container mt-4">
                    <div className="d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    return (
        <>
            <VineyardsListToolbar 
                onAddVineyard={() => navigate('/vineyards/new')}
                onAddWeighTag={() => navigate('/weight-tags')}
            />
            
            <div className="container mt-4">
                <div className="card">
                    <div className="card-body">
                        <div className="table-responsive">
                            <table className="table table-hover mb-0">
                                <thead>
                                    <tr>
                                        <th>Vineyard Name</th>
                                        <th>Location</th>
                                        <th>Acreage</th>
                                        <th>Varietals</th>
                                        <th>Contact</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {vineyards.map((vineyard) => (
                                        <tr 
                                            key={vineyard.id} 
                                            onClick={() => handleEdit(vineyard.id)}
                                            style={{ cursor: 'pointer' }}
                                            className="table-row-hover"
                                        >
                                            <td>{vineyard.vineyardName}</td>
                                            <td>
                                                {vineyard.location}<br />
                                                <small className="text-muted">
                                                    {vineyard.city}
                                                </small>
                                            </td>
                                            <td>{vineyard.acreage} acres</td>
                                            <td>{vineyard.varietals}</td>
                                            <td>
                                                {vineyard.firstName} {vineyard.lastName}<br />
                                                {vineyard.phone && (
                                                    <small className="text-muted">{vineyard.phone}</small>
                                                )}
                                            </td>
                                            <td>
                                                <button
                                                    className="btn btn-outline-danger btn-sm"
                                                    onClick={(e) => handleDelete(vineyard.id, e)}
                                                    title="Delete Vineyard"
                                                >
                                                    <Trash2 size={16} />
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <style jsx>{`
                .table-row-hover:hover td {
                    background-color: rgba(0,0,0,.075);
                }
                .table-row-hover {
                    transition: background-color 0.2s ease;
                }
                .btn svg {
                    vertical-align: middle;
                    margin-top: -2px;
                }
                .btn:hover svg {
                    transform: scale(1.1);
                    transition: transform 0.2s ease;
                }
                .btn:active svg {
                    transform: scale(0.95);
                }
            `}</style>
        </>
    );
};

export default VineyardsList;